<template>
  <div class="app-wrapper">
    <el-container style="height: 100%;">
      <el-header height="70px" style="padding: 0px;">
        <navbar></navbar>
      </el-header>
      <el-container>
        <el-aside width="200px">
          <menubar></menubar>
        </el-aside>
        <el-main>
          <appmain></appmain>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import appmain from './appmain';
import navbar from './navbar';
import menubar from './menubar';

export default {
  name: 'layout',
  components: {
    appmain,
    navbar,
    menubar,
  },
};
</script>

<style lang="less" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  /deep/ .el-aside {
    background-color: rgb(84, 92, 100);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue